import { DashboardConstants } from '../../actions/constant';

const {
  GET_INTERVENTION_GROUP_REQUEST,
  GET_INTERVENTION_GROUP_SUCCESS,
  GET_INTERVENTION_GROUP_FAILURE,
  GET_INTERVENTION_GROUP_LOADER,
  GET_INTERVENTION_GROUP_RESET,
} = DashboardConstants;
const intitialstate: object = {
  response: null,
  isIntervention: false,
  loading: false,
};

export const dashboardInterventionGroupReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_INTERVENTION_GROUP_SUCCESS: {
      return {
        ...state,
        isIntervention: true,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_INTERVENTION_GROUP_FAILURE:
      return {
        ...state,
        isIntervention: false,
        response: action.payload,
        loading: false,
      };

    case GET_INTERVENTION_GROUP_LOADER:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
